import { sessionService } from '@afterpaytouch/portal-api/consumer/sessions'

export const { useGetSessionsQuery, useDeleteSessionMutation } = sessionService
